module.exports = __webpack_public_path__ + "img/36.a1ac2df6.png";